var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2728 9.77622L7.63201 5.13715L12.2728 0.49835L16.8868 5.13715L12.2728 9.77622ZM0.302856 7.58486V1.03086H6.85925V7.58486H0.302856ZM9.80382 17.0823V10.5283H16.3602V17.0823H9.80382ZM0.302856 17.0823V10.5283H6.85925V17.0823H0.302856ZM1.67759 6.21063H5.48453V2.40509H1.67759V6.21063ZM12.2728 7.83275L14.9429 5.13715L12.2728 2.44156L9.57619 5.13715L12.2728 7.83275ZM11.1785 15.7081H14.9855V11.9026H11.1785V15.7081ZM1.67759 15.7081H5.48453V11.9026H1.67759V15.7081Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.a0c02f85cdec7a1f77486d9e5e999df5.svg";
export { ForwardRef as ReactComponent };